import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { toast } from "sonner";
import {
  FacebookLogo, XLogo, WhatsappLogo, PinterestLogo, EnvelopeSimple, ChatCircleText, LinkSimple, ShareNetwork,
} from "@phosphor-icons/react";

const enc = encodeURIComponent;
const tag = (url, s) => `${url}${url.includes("?") ? "&" : "?"}s=${s}`;

export default function ShareMenu({ url, text, title, image, testId = "share", triggerClassName = "", label = "Share" }) {
  const canNative = typeof navigator !== "undefined" && !!navigator.share;
  const links = [
    ["facebook", "Facebook", FacebookLogo, `https://www.facebook.com/sharer/sharer.php?u=${enc(tag(url, "fb"))}`],
    ["x", "X", XLogo, `https://twitter.com/intent/tweet?text=${enc(text)}&url=${enc(tag(url, "x"))}`],
    ["whatsapp", "WhatsApp", WhatsappLogo, `https://wa.me/?text=${enc(`${text} ${tag(url, "wa")}`)}`],
    ["pinterest", "Pinterest", PinterestLogo, `https://pinterest.com/pin/create/button/?url=${enc(tag(url, "pin"))}&description=${enc(text)}${image ? `&media=${enc(image)}` : ""}`],
    ["email", "Email", EnvelopeSimple, `mailto:?subject=${enc(title || text)}&body=${enc(`${text}\n\n${tag(url, "email")}`)}`],
    ["sms", "Text", ChatCircleText, `sms:?&body=${enc(`${text} ${tag(url, "sms")}`)}`],
  ];

  async function copy(link = tag(url, "copy")) {
    try { await navigator.clipboard.writeText(link); toast.success("Link copied — paste it anywhere!"); }
    catch { toast.error("Couldn't copy. Long-press the link instead."); }
  }
  async function native() {
    try { await navigator.share({ title: title || text, text, url: tag(url, "native") }); }
    catch (e) { if (e?.name !== "AbortError") copy(); }
  }

  const item = "flex items-center gap-2.5 px-3 h-10 rounded-sm text-sm hover:bg-muted transition-colors w-full text-left";
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" data-testid={`${testId}-btn`}
          className={triggerClassName || "h-12 px-4 rounded-sm border border-border hover:border-[#C84A31] flex items-center justify-center gap-2 text-sm transition-colors"}>
          <ShareNetwork size={18} /> {label}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-60 p-2 rounded-sm" data-testid={`${testId}-menu`}>
        {canNative && <button type="button" data-testid={`${testId}-native`} onClick={native} className={item}><ShareNetwork size={18} className="text-[#C84A31]" />Share via phone…</button>}
        <button type="button" data-testid={`${testId}-copy`} onClick={() => copy()} className={item}><LinkSimple size={18} className="text-[#C84A31]" />Copy link</button>
        <div className="h-px bg-border my-1" />
        {links.map(([k, name, Icon, href]) => (
          <a key={k} href={href} target={k === "email" || k === "sms" ? undefined : "_blank"} rel="noopener noreferrer"
            data-testid={`${testId}-${k}`} className={item}>
            <Icon size={18} weight={k === "x" ? "regular" : "fill"} className="text-[#1C211E]/70" />{name}
          </a>
        ))}
      </PopoverContent>
    </Popover>
  );
}
